<template>
    <div>
        <div class="DataCreateInsti">
            <div>{{$t('DataDetails.dataContributors')}}：</div>
            <div class="content">{{DataCreate.creator}}({{DataCreate.createInsti}})</div>
        </div>
    </div>
</template>

<script>
export default {
    props:['DataCreate']
}
</script>

<style lang="scss" scoped>
.DataCreateInsti{
    margin-top: 10px;
    display: flex;
    font-size: 14px;
    .content{
        color:rgba(0, 120, 212, 1);
    }
}

</style>